<template>
    <HierarchyViewAlt container="ratioReports"></HierarchyViewAlt>    
</template>

<script>
import HierarchyViewAlt from "@/components/jobArchitecture/HierarchyViewAlt";

export default {
  name: "ReportContainer",
  components: {
    HierarchyViewAlt
  },
  props: { },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>
</style>